import React from 'react';
import {BrowserRouter as Router,Route} from 'react-router-dom';

import Join from './components/Join/Join';
import chat from './components/Chat/Chat';

const App = () => (

    <Router>
            <Route exact path='/' component={Join} />
            <Route path='/components/chat' component={chat} />
    </Router>
);


export default App;


